import QashqoolLogo from "@/assets/images/qashqool-logo-light-slim.svg?react";
import WhatsAppLogo from "@/assets/images/whatsapp.svg?react";
import usePWA from "@/hooks/usePWA";
import { useAppSelector } from "@/store/hooks";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";

function Footer() {
  const { isAppInstalled } = usePWA();
  const { portal } = useAppSelector((state) => state.store);
  const location = useLocation();
  const navigate = useNavigate();

  if (isAppInstalled) return <></>;

  if (location.pathname.indexOf("/live/") !== -1) return <></>;

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <QashqoolLogo className="w-25 h-15 rounded-lg bg-white p-1" />
            </div>
            <p className="text-gray-400">
              شركة كشكول لإنشاء المواقع التعليمية و إدارة التعليم
            </p>
          </div>
          <div>
            <h3 className="font-semibold mb-4">روابط سريعة</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button
                  className="hover:text-white cursor-pointer"
                  onClick={() => {
                    const authForm = document.getElementById("auth-form");
                    if (authForm) {
                      authForm.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    } else {
                      navigate("/");
                      scrollTo(0, 0);
                    }
                  }}
                >
                  دخول الطالب
                </button>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-white">
                  شروط الاستخدام و سياسة الخصوصية
                </Link>
              </li>
              <li>
                <a
                  href="https://qashqool.com/#pricing"
                  className="hover:text-white"
                >
                  مميزات و اسعار منصة كشكول
                </a>
              </li>
              <li>
                <a href="https://qashqool.com" className="hover:text-white">
                  إحصل على منصتك الخاصة من كشكول الآن
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold mb-4">تواصل معنا</h3>
            <p className="text-gray-400 text-right flex flex-col gap-2">
              <span dir="ltr">qashqool.edu@gmail.com : بريد الكتروني</span>
              <span dir="ltr">واتساب : 01012376009</span>
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p dir="ltr">&copy; 2025 جميع الحقوق محفوظة</p>
        </div>
      </div>
      <a
        href={`https://api.whatsapp.com/send?phone=${
          // portal?.whatsapp_number
          "201012376009"
        }`}
        target="_blank"
        className="fixed right-[2%] bottom-[2%] z-50 bg-green-500 p-4 rounded-full"
        style={{
          bottom: isAppInstalled ? "80px" : "40px",
        }}
      >
        <WhatsAppLogo className="size-5 fill-white" />
      </a>
    </footer>
  );
}

export default Footer;
